import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SwitchComponent } from '../../../components/switch/switch.component';
import { AccessItemCtaComponent } from '../access-item-cta/access-item-cta.component';
import { AccessItemHeaderComponent } from '../access-item-header/access-item-header.component';
import { AccessItemIconComponent } from '../access-item-icon/access-item-icon.component';
import { AccessItemComponent } from '../access-item/access-item.component';
import { GallerySettingsIconComponent } from '../gallery-settings-icon/gallery-settings-icon.component';

@Component({
  selector: 'app-theme-asset-page-viewing-controls-item',
  imports: [
    AccessItemComponent,
    AccessItemIconComponent,
    AccessItemHeaderComponent,
    AccessItemCtaComponent,
    GallerySettingsIconComponent,
    SwitchComponent,
    FormsModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './theme-asset-page-viewing-controls-item.component.html',
  styleUrl: './theme-asset-page-viewing-controls-item.component.scss',
})
export class ThemeAssetPageViewingControlsItemComponent {}
